import { ISensorData, ISensorDataExtended } from "./ISensor";

export interface IUser {
    id?: string
    owUserId?: string
    provider?: string
    firstName?: string
    lastName?: string
    email?: string
    culture?: string
    role?: UserRole
    parentId?: string
    createdAt?: Date
    lastValueAt?: Date
    enrolmentAt?: Date
    devicesData?: IDeviceData[]
    aiTags?: IAITag[]
    meta?: string
    initials?: string
    lastSyncedAt?: Date
    lastSyncedFrom?: string
}

export enum UserRole {
    Admin,
    Manager,
    Clinician,
    Patient
}

export interface IDeviceData {
    id: string
    sensorsData: ISensorData[]
}

export interface IDeviceDataExtended {
    id: string
    brandId: string
    name: string
    sensorsDataExtended: ISensorDataExtended[]
}

export enum UserProviderId {
    EXCARE = "EXCARE",
    CHAMP = "CHAMP",
    KORE = "KORE",
    AIQReady = "AIQReady",
    SMILE = "SMILE",
    VETLLAR = "VETLLAR",
    AURA = "AURA",
    ICARE = "ICARE",
    COMPASS = "COMPASS",
    CERTAIN = "CERTAIN"
}

export enum UserProviderName {
    EXCARE = "EXCARE",
    CHAMP = "CHAMP",
    KORE = "KORE",
    AIQReady = "A-IQ Ready",
    SMILE = "SMILE",
    VETLLAR = "VETLLAR",
    AURA = "AURA",
    ICARE = "ICARE",
    COMPASS = "COMPASS",
    CERTAIN = "CERTAIN"
}

export interface IAITag {
    literalKey: string
    color: string
}